<template>
  <b-card header="Waitlist by Organ" class="mb-3">
    <apexchart
      v-if="series.length > 0"
      type="donut"
      height="350"
      :options="chartOptions"
      :series="series"
    />
    <div v-else class="text-center text-muted py-5">No data available</div>
  </b-card>
</template>

<script>
export default {
  props: {
    data: { type: Array, default: () => [] },
  },
  computed: {
    chartOptions() {
      return {
        labels: this.data.map((d) => d.organ_name),
        colors: ["#007bff", "#28a745", "#dc3545", "#ffc107", "#17a2b8", "#6f42c1"],
        legend: { position: "bottom" },
      };
    },
    series() {
      return this.data.map((d) => Number(d.count) || 0);
    },
  },
};
</script>
